<template>
  <v-container class="pa-0 person-dialog-form-container">
    <div class="request-a-call-dialog-container">
      <p v-if="errorMessage" id="error" class="error-message mt-2 text-start">
        {{ errorMessage }}
      </p>
      <ValidationObserver ref="observer">
        <v-form class="request-a-call-form" ref="requestACallForm">
          <div class="inputs-inner">
            <ValidationProvider
              id="first_names"
              v-slot="{ errors }"
              name="first_names"
              rules="required"
            >
              <TextField
                v-model.trim="person.firstName"
                :label="'Name*'"
                :errors="errors"
                :name="'first_names'"
              />
            </ValidationProvider>
            <ValidationProvider
              id="last_name"
              v-slot="{ errors }"
              name="last_name"
              rules="required"
            >
              <TextField
                v-model.trim="person.surname"
                :label="'Surname*'"
                :errors="errors"
                :name="'last_name'"
              />
            </ValidationProvider>
            <ValidationProvider
              id="email"
              v-slot="{ errors }"
              name="email"
              rules="email|required"
            >
              <TextField
                v-model.trim="person.email"
                :label="'Email*'"
                :errors="errors"
                :name="'email'"
              />
            </ValidationProvider>

            <ValidationProvider
              id="cell_number"
              v-slot="{ errors }"
              name="cell_number"
              :rules="{ required: true, phoneIntl: [phoneCountryCode] }"
            >
              <TextField
                v-model.trim="person.contactNumber"
                :label="'Phone number'"
                :errors="errors"
                :name="'cell_number'"
              >
                <template #prepend>
                  <vue-tel-input
                    :preferred-countries="['ZA', 'GB']"
                    :default-country="phoneCountryDefault"
                    @country-changed="countrySelected"
                  >
                    <template #arrow-icon>
                      <strong>{{ countryDialCode }}</strong>
                    </template>
                  </vue-tel-input>
                </template>
              </TextField>
            </ValidationProvider>

            <div class="terms-and-conditions-container">
              <ValidationProvider
                id="accepted_terms"
                v-slot="{ errors }"
                name="accepted_terms"
                :rules="{ is: [true] }"
              >
                <v-checkbox
                  v-model="acceptedTerms"
                  color="primary"
                  :error-messages="errors"
                >
                  <template #label>
                    <span
                      >By signing up, I accept&nbsp;
                      <a
                        v-if="['oldmutual', 'teba'].includes(whitelabel.brand)"
                        :href="
                          $router.resolve({
                            path: 'terms-and-conditions',
                          }).href
                        "
                        target="_blank"
                        @click.stop
                      >
                        {{ whitelabel.name }}'s terms & conditions
                      </a>
                      <a
                        v-if="whitelabel.brand == 'quickwill'"
                        target="_blank"
                        :href="whitelabel.termsAndConditionsLocation"
                        @click.stop
                        >{{ whitelabel.name }}'s terms & conditions</a
                      >
                    </span></template
                  >
                </v-checkbox>
              </ValidationProvider>
            </div>
          </div>
        </v-form>
      </ValidationObserver>

      <div class="crud-card-actions pb-0">
        <div class="button-container">
          <GradientButton
            :title="dialogButtonText"
            :small="true"
            :type="'submit'"
            :callout="'right'"
            :disabled="isButtonDisabled"
            @gradientButtonClicked="save"
          />
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { CREATE_WEBSITE_LEAD_MUTATION } from "../../../constants/graphql/website-leads";
import { parsePhoneNumber } from "awesome-phonenumber";
export default {
  name: "RequestACallDialogForm",
  components: {
    CREATE_WEBSITE_LEAD_MUTATION,
  },
  props: {},
  mounted() {},
  data() {
    return {
      acceptedTerms: false,
      countryDialCode: null,
      phoneCountryDefault: "ZA",
      phoneCountryCode: null,
      person: {
        firstName: null,
        surname: null,
        email: null,
        contactNumber: null,
        userAgent: null,
        referrer: null,
      },
      buttonLoading: false,
      errorMessage: null,
      vueTelInputKey: "initial-load",
    };
  },
  computed: {
    phoneNumberSignificant() {
      const pn = parsePhoneNumber(
        this.person.contactNumber,
        { regionCode: this.phoneCountryCode }
      );
      return pn.valid ? pn.number.significant : this.person.contactNumber;
    },
    isMobile() {
      return this.$isMobileDevice();
    },
    dialogButtonText() {
      return this.isMobile ? "Call Me Back" : "Call Me Back To Set Up My Will";
    },
    isButtonDisabled() {
      const lastRequestTimestamp = localStorage.getItem('logged_out_request_a_call_timestamp');
      if (lastRequestTimestamp) {
        const currentTime = Date.now();
        const timeSinceLastRequest = currentTime - parseInt(lastRequestTimestamp);
        const oneHourInMs = 60 * 60 * 1000; // 1 hour in milliseconds
        return timeSinceLastRequest < oneHourInMs;
      }
      return false;
    },
  },
  methods: {
    save() {
      if (this.isButtonDisabled) return;
      
      this.$refs.observer.validate().then((valid) => {
        if (valid) {
          dataLayer.push({
            event: "callbacksubmitted",
            omuserid: this.$store.getters?.userId,
            omtid: this.$store.getters.omtId,
            emailaddress: this.person.email,
            phonenumber: this.person.contactNumber,
          });

          this.person.contactNumber = `${this.countryDialCode}${this.phoneNumberSignificant}`;
          this.createWebsiteLead();
          this.buttonLoading = true;
        } else {
          const errors = this.$refs.observer.ctx.errors;
        }
      });
    },
    closeDialog(success) {
      if (success) {
        this.$refs.requestACallForm.reset();
        this.$emit("success", true);
        this.buttonLoading = false;
      } else {
        this.$emit("success", false);
        this.buttonLoading = false;
      }
    },
    countrySelected(val) {
      this.phoneCountryCode = val.iso2;
      this.countryDialCode = "+" + val.dialCode.toString();
    },
    createWebsiteLead() {
      this.$apollo
        .mutate({
          mutation: CREATE_WEBSITE_LEAD_MUTATION,
          variables: { websiteLeadInput: this.person },
        })
        .then((response) => {
          localStorage.setItem('logged_out_request_a_call_timestamp', Date.now().toString());
          this.closeDialog(true);
        })
        .catch((error) => {
          this.closeDialog(false);
        });
    },
    checkLocalStorage() {
      // Force reactivity update by accessing the computed property
      this.$forceUpdate();
    }
  },
  mounted() {
    this.person.userAgent = navigator.userAgent;
    this.person.referrer = document.referrer;
    this.checkLocalStorage();
  },
};
</script>

<style lang="scss" scoped>
.inputs-inner {
  margin-bottom: 40px;
}

.terms-and-conditions-container {
  span,
  a {
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 21px !important;
    color: #282828 !important;
  }
}

input[name="telephone"] {
  display: none;
}
</style>
